(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvWorkflowResponseCreateEntity', drvWorkflowResponseCreateEntity);

    drvWorkflowResponseCreateEntity.$inject = ['$q', 'WorkflowRunService', 'DialogService', '$timeout'];
    
    function drvWorkflowResponseCreateEntity($q, WorkflowRunService, DialogService, $timeout) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: true,
            templateUrl: 'app/workflow/responses/workflow-response-create-entity.tmpl.html'
        };
        return directive;

        function link(scope, element, attrs) {
            scope.responseInProgress = false;
            scope.entityId = '';

            scope.ok = function () {
                if (scope.entityId.length > 0) {
                    scope.responseInProgress = true;

                    WorkflowRunService.respondToStep(scope.instanceId, scope.step.StepId, scope.entityId)
                        .catch(function (response) {
                            scope.responseInProgress = false;
                            DialogService.error('Error responding to Workflow step', response);
                            return $q.reject(response);
                        });
                }
            };
        }
    }
})();